<script setup lang="ts">
import { useToastStore } from '@/stores/toast'
const toast = useToastStore()
</script>

<template>
  <div id="toast" :class="{ ng: toast.type === 'ng' }" v-if="toast.message">
    {{ toast.message }}
  </div>
</template>